export default __webpack_public_path__ + "static/media/powered-by.1c8d4f58.svg";